<template>
    <div :class="$style.actions">
        <div >
            <template v-if="row.ImagePath2 === '~/Images/cross.gif'">
                <div v-html="row.timeout"></div> <!--sagar changes add timeOut field in attendance report  -->
                <img :src="require(`Assets/images/cross.png`)" :class="$style.redCrossImage"/>
            </template>
            <template v-else>
                <div v-html="row.timeout"></div><!--sagar changes add timeOut field  in attendance report-->
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ActionsCellOut",
        props: {
            row: {
                type: Object,
                required: true,
            }
        },
        computed:{
            userData() {
                return this.$store.state.user.user
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>

<style lang="scss" module>
    .actions {
        display: flex;
        div {
            margin: 0px 7px 0px 0px;
            color: #515a6e;
            display: inline-block;
        }
    }

    .redCrossImage{
        width: 15px;
    }
</style>

